import { DateRange } from 'react-day-picker';
import { addYears } from 'date-fns';
import { DateRangePicker } from '../../form-components';
import { cn, MAX_DATE_FILTER_YEARS } from '../../utils';

export interface DateFilterProps {
  onRangeSelect: (range: DateRange | null) => void;
  from: Date | null;
  to: Date | null;
  disabled?: boolean;
  placeholder?: string;
}

export const DateFilter = ({
  onRangeSelect,
  from,
  to,
  disabled = false,
  placeholder,
}: DateFilterProps) => {
  const maxDate = addYears(new Date(), MAX_DATE_FILTER_YEARS);
  const selected: DateRange | null = from ? { from, ...(to && { to }) } : null;

  return (
    <DateRangePicker
      closeOnScroll
      selected={selected}
      onSelect={onRangeSelect}
      captionLayout="dropdown"
      endMonth={maxDate}
      disabled={disabled}
      placeholder={placeholder}
      buttonProps={{
        onClick: e => e.stopPropagation(),
        className: cn(
          'h-[30px] p-0 px-1 gap-1 border-0 items-center bg-white hover:brightness-100 text-primary',
          disabled && 'cursor-not-allowed opacity-60'
        ),
        disabled,
      }}
    />
  );
};
